<template>
  <div>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <!-- <p slot="title">代理服务</p> -->
      <Form
        style="margin: 30px 20px"
        :model="formItem"
        :label-width="150"
        label-position="left"
      >
        <div class="formRow">
          <div class="formCol" v-if="showSelfData.agencyCode == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.agencyCode : enNameMap.agencyCode
              "
            >
              <Input
                :disabled="disableSelfData.agencyCode"
                v-model="formItem.agencycode"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.agencyName == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.agencyName : enNameMap.agencyName
              "
            >
              <Input
                :disabled="disableSelfData.agencyName"
                v-model="formItem.agencyname"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.contractType == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.contractType : enNameMap.contractType
              "
            >
              <Input
                :disabled="disableSelfData.contractType"
                v-model="formItem.contracttype"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.contractStartDate == '1'">
            <FormItem
              :label="
                lang == 'zh'
                  ? chNameMap.contractStartDate
                  : enNameMap.contractStartDate
              "
            >
              <DatePicker
                type="date"
                :disabled="disableSelfData.contractStartDate"
                v-model="formItem.contractstartdate"
              ></DatePicker>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.contractEndDate == '1'">
            <FormItem
              :label="
                lang == 'zh'
                  ? chNameMap.contractEndDate
                  : enNameMap.contractEndDate
              "
            >
              <DatePicker
                type="date"
                :disabled="disableSelfData.contractEndDate"
                v-model="formItem.contractenddate"
              ></DatePicker>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.contractNumber == '1'">
            <FormItem
              :label="
                lang == 'zh'
                  ? chNameMap.contractNumber
                  : enNameMap.contractNumber
              "
            >
              <Input
                :disabled="disableSelfData.contractNumber"
                v-model="formItem.contractnumber"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.dangAn == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.dangAn : enNameMap.dangAn"
            >
              <Input
                :disabled="disableSelfData.dangAn"
                v-model="formItem.dangan"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.monthManagefee == '1'">
            <FormItem
              :label="
                lang == 'zh'
                  ? chNameMap.monthManagefee
                  : enNameMap.monthManagefee
              "
            >
              <Input
                :disabled="disableSelfData.monthManagefee"
                v-model="formItem.monthmanagefee"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.medicalPercentage == '1'">
            <FormItem
              :label="
                lang == 'zh'
                  ? chNameMap.medicalPercentage
                  : enNameMap.medicalPercentage
              "
            >
              <Input
                :disabled="disableSelfData.medicalPercentage"
                v-model="formItem.medicalpercentage"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.pensionContribution == '1'">
            <FormItem
              :label="
                lang == 'zh'
                  ? chNameMap.pensionContribution
                  : enNameMap.pensionContribution
              "
            >
              <Input
                :disabled="disableSelfData.pensionContribution"
                v-model="formItem.pensioncontribution"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.hfContribution == '1'">
            <FormItem
              :label="
                lang == 'zh'
                  ? chNameMap.hfContribution
                  : enNameMap.hfContribution
              "
            >
              <Input
                :disabled="disableSelfData.hfContribution"
                v-model="formItem.hfcontribution"
              />
            </FormItem>
          </div>
          <div class="formCol"></div>
        </div>
      </Form>
    </Card>
    <div class="bottomBtn">
      <Button type="primary" :disabled="isClick"  @click="saveData()">保存</Button>
      <Button v-if="plan" @click="returnPage()" style="margin-left: 15px"
        >返回</Button
      >
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import axios from "axios";
import watermark from "@/util/watermark";
import DateUtil from "@/util/DateUtil";

export default {
  data() {
    return {
      date: new DateUtil(),
      oldFormItem: {},
      formItem: {},
      loading: false,
      disableSelfData: {},
      showSelfData: {},
      plan: null,
      id: null,
      chNameMap: {},
      enNameMap: {},
      userId: ""
    };
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userId = userInfo.serialnumber;
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    getWaterMarkStatus() {
      return this.$store.getters.getWaterMarkStatus == 1
        ? watermark.addWaterMark()
        : "";
    },
    isClick() {
      return JSON.stringify(this.getNewValue()) == "{}" 
    }
  },
  methods: {
    getData(id, plan) {
      this.plan = plan ? plan : "";
      this.id = id;
      this.getTableData();
    },
    getTableData() {
      let obj = {
        sheetId: this.id,
        serialnumber: this.plan ? this.plan : this.userId,
        bePersonal: this.plan ? "0" : "1" // 1:个人 0：员工
      };
      this.loading = true;
      axios.post("/AgencyServices/searchUserAgencyServices", obj).then(res => {
        this.loading = false;
        if (res) {
          this.formItem = res.data.length > 0 ? res.data[0] : {};
          for (var item in this.formItem) {
               if (typeof(this.formItem[item]) == 'string'  && this.formItem[item].indexOf('1900-01-01') != -1) {
                this.formItem[item] = ''
               }
            }
          this.oldFormItem = JSON.parse(JSON.stringify(this.formItem));
          this.showSelfData = res.showSelfData;
          this.disableSelfData = res.disableSelfData;
          this.chNameMap = res.chNameMap;
          this.enNameMap = res.enNameMap;
          this.disablePopin(this.disableSelfData);
        }
      });
    },
    // 配置右侧可编辑，1=false可编辑，0=true不可编辑
    disablePopin(disableSelfData) {
      for (var key in disableSelfData) {
        if (disableSelfData[key] == 0) {
          disableSelfData[key] = true;
        } else {
          disableSelfData[key] = false;
        }
      }
    },
    getNewValue() {
      let obj = {};
      for (var item in this.formItem) {
        if (this.oldFormItem[item] != this.formItem[item]) {
          if (this.formItem[item] instanceof Date) {
              this.formItem[item] = this.date.dateVal(this.formItem[item], "YYYY-MM-DD")
          }
          if (typeof this.oldFormItem[item] == "object") {
            if (
              this.oldFormItem[item].join("") != this.formItem[item].join("")
            ) {
              obj[item] = this.formItem[item];
            }
          } else {
            obj[item] = this.formItem[item];
          }
        }
      }
      return obj;
    },
    saveData() {
      let newFormItem = this.getNewValue();
      console.log(newFormItem,'new')
      console.log(this.formItem,'new')
      console.log(this.oldFormItem,'new')
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        content: "",
        onOk: () => {
          let obj = {
            serialnumber: this.plan ? this.plan : this.userId,
            ...newFormItem
          };
          axios
            .post("/AgencyServices/rollBackUserAgencyData", obj)
            .then(res => {
              if (res) {
                this.$Message.info(res);
                this.getTableData();
              }
            });
        },
        onCancel: () => {}
      });
    },
    returnPage() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.formRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.formCol {
  width: calc((100% - 210px) / 3);
  float: left;
}
@media screen and (max-width: 1300px) and (min-width: 800px) {
  .formCol {
    width: calc((100% - 40px) / 2);
  }
}
@media screen and (max-width: 800px) {
  .formCol {
    width: 100%;
  }
}
.bottomBtn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.ivu-date-picker {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/components/AgencyService.vue